import { Controller } from "stimulus"

function validTarget(el) {
  return el.form && !el.form.hasAttribute("aria-busy")
}

export default class extends Controller {
  validate = ({ target, params }) => {
    if (validTarget(target)) {
      const submitter = this.#createSubmitter(params.action)
      target.form.append(submitter)
      target.form.requestSubmit(submitter)
    }
  }

  #createSubmitter(action) {
    if (!action) { return null }

    const submitter = document.createElement('input')
    submitter.type = 'submit'
    submitter.style.display = 'none'
    submitter.setAttribute('formaction', action)
    submitter.setAttribute('formmethod', 'POST')

    return submitter
  }
}
